module.exports = __webpack_public_path__ + "static/media/view leave by student.57f34a90.svg";